import { lazy, Suspense } from "react";
import Chat from "../pages/apps/chat/Chat";
import Inbox from "../pages/apps/inbox/Inbox";
import NotFound from "../pages/sessions/NotFound";
import Loading from "../components/loading/Loading";
import AuthGuard from "../components/auth/AuthGuard";
import AppCards from "../pages/ui-kits/cards/AppCards";
import AppButtons from "../pages/ui-kits/buttons/AppButtons";
import ApexCharts from "../pages/charts/apexchart/ApexCharts";
import Dashboard1 from "../pages/dashboard/dashboard1/Dashboard1";
import Dashboard2 from "../pages/dashboard/dashboard2/Dashboard2";
import Dashboard3 from "../pages/dashboard/dashboard3/Dashboard3";
import Dashboard4 from "../pages/dashboard/dashboard4/Dashboard4";
import Dashboard5 from "../pages/dashboard/dashboard5/Dashboard5";
import BasicTable from "../pages/data-tables/basic-table/BasicTable";
import AddCustomer from "../pages/customers/add-customer/AddCustomer";
import CustomerLists from "../pages/customers/customer-lists/CustomerLists";
import CustomerDetails from "../pages/customers/customer-details/CustomerDetails";
import AdvanceSortedTable from "../pages/data-tables/sorted-table/SortedTable";

const Loadable = (Component: any) => (props: any) =>
  (
    <Suspense fallback={<Loading />}>
      <Component {...props} />
    </Suspense>
  );

// Dashboard page
const DashboardLayout = Loadable(
  lazy(() => import("../Layouts/DashboardLayout"))
);

// authentication pages
const Signin = Loadable(lazy(() => import("../pages/sessions/Signin")));
const Signup = Loadable(lazy(() => import("../pages/sessions/Signup")));
const ForgotPassword = Loadable(
  lazy(() => import("../pages/sessions/ForgotPassword"))
);

// routes
export const all_routes = [
  {
    path: "/",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "dashboard/v1",
        element: <Dashboard1 />,
      },
      {
        path: "dashboard/v2",
        element: <Dashboard2 />,
      },
      {
        path: "dashboard/v3",
        element: <Dashboard3 />,
      },
      {
        path: "dashboard/v4",
        element: <Dashboard4 />,
      },
      {
        path: "dashboard/v5",
        element: <Dashboard5 />,
      },
      {
        path: "uikits/cards",
        element: <AppCards />,
      },
      {
        path: "uikits/buttons",
        element: <AppButtons />,
      },
      {
        path: "customers/add",
        element: <AddCustomer />,
      },
      {
        path: "customers/list",
        element: <CustomerLists />,
      },
      {
        path: "customers/details",
        element: <CustomerDetails />,
      },
      {
        path: "apps/inbox",
        element: <Inbox />,
      },
      {
        path: "apps/chat",
        element: <Chat />,
      },
      {
        path: "charts/apexcharts",
        element: <ApexCharts />,
      },
      {
        path: "/datatables/basic-table",
        element: <BasicTable />,
      },
      {
        path: "/datatables/sorted-table",
        element: <AdvanceSortedTable />,
      },
    ],
  },
  {
    path: "/session/signin",
    element: <Signin />,
  },
  {
    path: "/session/signup",
    element: <Signup />,
  },
  {
    path: "/session/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/session/404",
    element: <NotFound />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

// routes
export const openRoutes = [
  {
    path: "/session/signin",
    element: <Signin />,
  },
  {
    path: "/session/signup",
    element: <Signup />,
  },
  {
    path: "/session/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/session/404",
    element: <NotFound />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];
